import { IntervalDTO, IntervalStripped } from 'models'

const convertIntervalDTO = (intervalDTO: IntervalDTO) => {
  const result: IntervalStripped = {
    tableName: intervalDTO.tableName,
    isActive: intervalDTO.isActive,
    frequency: intervalDTO.executionSchedule.frequency,
    executionTime: intervalDTO.executionSchedule.executionTime,
    specificDays: intervalDTO.executionSchedule.specificDays,
    startDate: intervalDTO.executionSchedule.startDate,
    endDate: intervalDTO.executionSchedule.endDate,
  }
  return result
}

export { convertIntervalDTO }
